import React, { useEffect, useState } from 'react';
import Form from 'antd-mobile/es/components/form';
import Input from 'antd-mobile/es/components/input';
import Toast from 'antd-mobile/es/components/toast';
import classNames from 'classnames';
import { Button } from '../H5Button/button';
import styles from './index.module.scss';
import { CompanyPopup } from '../H5FormItem/CompanyPopup';
import { createBrandItem } from '../../apis';
import { useTranslation } from '../../LangContext';
import { CityPopup } from '../H5FormItem/CityPopup';
import { MTDIcon } from '../../../../components/Icon';
import PopupTitle from '../PopupTitle';

interface Props {
  onClose(): void;
}
export const H5Form = (props: Props) => {
  const [form] = Form.useForm();
  const { onClose } = props;

  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);
  const [cityPopupVisible, setCityPopupVisible] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [brandCity, setBrandCity] = useState('');

  // 是否展示额外的输入框
  const onValuesChange = (_: Record<string, any>, allValues: Record<string, any>) => {
    const changed = allValues.brandCity;
    if (brandCity !== changed) {
      setBrandCity(changed);
      form.setFieldValue('brandName', '');
    }
    if (changed) {
      setVisible(true);
    } else {
      setVisible(false);
    }
    setSubmitDisabled(!(allValues.brandCity && allValues.brandName && allValues.contactName && allValues.contactPhone));
  };

  const onSubmit = () => {
    form.validateFields().then((formValues) => {
      setVisible(false);
      createBrandItem({ ...formValues, businessType: 'LAO_ZI_HAO' })
        .then(() => {
          Toast.show({
            content: <div style={{ textAlign: 'center' }}>{t('successTips')}</div>,
          });
        })
        .catch(() => {
          Toast.show({
            content: <div style={{ textAlign: 'center' }}>{t('failTips')}</div>,
          });
        })
        .finally(() => {
          onClose();
          form.setFieldsValue({ brandCity: '', brandName: '', contactName: '', contactPhone: '' });
          setVisible(false);
        });
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setCityPopupVisible(true);
      clearTimeout(timer);
    }, 200);
  }, []);

  return (
    <div className={styles.formContainer}>
      <PopupTitle onClose={onClose} title={t('applyTitle')} />
      <div className={styles.formContainerInner}>
        <div>
          <div className={styles.alert}>
            <MTDIcon className={styles.alertIcon} icon="mtdicon-info-circle" />
            {t('applyTooltips')}
          </div>
          <Form
            form={form}
            onValuesChange={onValuesChange}
            initialValues={{ brandName: '', contactName: '', contactPhone: '' }}
          >
            <Form.Item
              name="brandCity"
              label={t('formConfig.cityLabel')}
              rules={[{ required: true, message: t('formConfig.cityErrorTips') }]}
            >
              {cityPopupVisible && <CityPopup />}
            </Form.Item>
            {visible && (
              <>
                <Form.Item
                  name="brandName"
                  label={t('formConfig.brandLabel')}
                  rules={[
                    {
                      required: true,
                      message: t('formConfig.brandErrorTips'),
                    },
                  ]}
                >
                  <CompanyPopup city={brandCity} />
                </Form.Item>
                <Form.Item
                  name="contactName"
                  label={t('formConfig.contactNameLabel')}
                  rules={[
                    {
                      required: true,
                      message: t('formConfig.contactNameErrorTips'),
                    },
                    {
                      max: 20,
                      message: t('formConfig.contactNameErrorTips'),
                    },
                    {
                      min: 1,
                      message: t('formConfig.contactNameErrorTips'),
                    },
                  ]}
                >
                  <Input placeholder={t('formConfig.contactNamePlaceholder')} />
                </Form.Item>
                <Form.Item
                  name="contactPhone"
                  label={t('formConfig.contactPhoneLabel')}
                  rules={[
                    {
                      required: true,
                      message: t('formConfig.contactPhoneErrorTips'),
                    },
                    {
                      pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                      message: t('formConfig.contactPhoneErrorTips'),
                    },
                  ]}
                >
                  <Input placeholder={t('formConfig.contactPhonePlaceholder')} maxLength={11} />
                </Form.Item>
              </>
            )}
          </Form>
        </div>

        <div className={styles.footer}>
          <div className={classNames(styles.footerItem, styles.cancelBtn)}>
            <Button block onClick={onClose}>
              {t('formConfig.cancelBtnText')}
            </Button>
          </div>
          <div className={classNames(styles.footerItem, styles.okBtn)}>
            <Button disabled={submitDisabled} block type="primary" onClick={onSubmit}>
              {t('formConfig.submitBtnText')}
            </Button>
          </div>
        </div>
      </div>
      )
    </div>
  );
};
